module.exports = __webpack_public_path__ + "static/img/number.1e0e68be.svg";